import { DOCUMENT, Injectable, effect, inject, signal } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class ThemeService {
	private readonly document = inject(DOCUMENT);

	readonly dark = signal(this.initialDark());

	constructor() {
		effect(() => this.document.documentElement.classList.toggle('dark', this.dark()));
	}

	toggle(): void {
		const dark = !this.dark();
		this.dark.set(dark);
		localStorage.setItem('theme', dark ? 'dark' : 'light');
	}

	private initialDark(): boolean {
		const prefersDark = this.document.defaultView?.matchMedia('(prefers-color-scheme: dark)').matches ?? false;
		try {
			const stored = localStorage.getItem('theme');
			return stored ? stored === 'dark' : prefersDark;
		} catch {
			return prefersDark;
		}
	}
}
